import Marquee from 'react-fast-marquee';

const MarqueeStrip = () => {
  const items = [
    'Sign Boards',
    'Digital Signage',
    'LED Displays',
    'Flex Printing',
    'Road Signs',
    'Internal Signage',
    'Video Walls',
    'Laser Cutting',
    'Backlit Signs',
    'Neon Signs'
  ];

  return (
    <section
      data-testid="marquee-strip"
      className="py-8 md:py-12 border-y border-border overflow-hidden"
    >
      <div className="marquee-mask">
        <Marquee
          speed={40}
          gradient={false}
          className="overflow-hidden"
        >
          {items.map((item, index) => (
            <div
              key={index}
              className="flex items-center mx-8 md:mx-12"
            >
              <span className="text-2xl md:text-4xl lg:text-5xl font-light tracking-tight text-muted-foreground/30 font-['DM_Sans'] uppercase whitespace-nowrap">
                {item}
              </span>
              <span className="ml-8 md:ml-12 w-2 h-2 rounded-full bg-muted-foreground/20" />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  );
};

export default MarqueeStrip;
